var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_6196_24389)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40Z",
    fill: "url(#paint1_linear_6196_24389)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.666 23.333C35.3399 23.333 34.0682 23.8598 33.1305 24.7975C32.1928 25.7352 31.666 27.0069 31.666 28.333V29.9997H26.666C23.9046 29.9997 21.666 32.2383 21.666 34.9997V51.6663C21.666 54.4278 23.9046 56.6663 26.666 56.6663H53.3327C56.0941 56.6663 58.3327 54.4278 58.3327 51.6663V34.9997C58.3327 32.2383 56.0941 29.9997 53.3327 29.9997H48.3327V28.333C48.3327 27.0069 47.8059 25.7352 46.8682 24.7975C45.9305 23.8598 44.6588 23.333 43.3327 23.333H36.666ZM44.9993 29.9997V28.333C44.9993 27.891 44.8238 27.4671 44.5112 27.1545C44.1986 26.8419 43.7747 26.6663 43.3327 26.6663H36.666C36.224 26.6663 35.8001 26.8419 35.4875 27.1545C35.1749 27.4671 34.9993 27.891 34.9993 28.333V29.9997H44.9993ZM34.9993 33.333H44.9993V53.333H34.9993V33.333ZM31.666 33.333H26.666C25.7455 33.333 24.9993 34.0792 24.9993 34.9997V51.6663C24.9993 52.5868 25.7455 53.333 26.666 53.333H31.666V33.333ZM48.3327 53.333V33.333H53.3327C54.2532 33.333 54.9993 34.0792 54.9993 34.9997V51.6663C54.9993 52.5868 54.2532 53.333 53.3327 53.333H48.3327Z",
    fill: "#fbfbfb"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6196_24389",
    x1: -20,
    y1: 0,
    x2: 89.6875,
    y2: 92.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBCFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6196_24389",
    x1: -20,
    y1: 0,
    x2: 89.6875,
    y2: 92.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBCFFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessUser);
export default __webpack_public_path__ + "static/media/BusinessUser.f2dce8fee1d105f6df4969cbef5cc602.svg";
export { ForwardRef as ReactComponent };